import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _withScopeId = n => (_pushScopeId("data-v-0e57d6de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal formContainer uploadExcelModal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "my-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "table table-striped my-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs_12" }, "KgCo2e", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs_12" }, "KgCo2e", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs_12" }, "KgCo2e", -1))
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-sm-4" }
const _hoisted_17 = { class: "col-sm-4" }
const _hoisted_18 = { class: "col-sm-4" }
const _hoisted_19 = { class: "text-center mt-5" }
const _hoisted_20 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "New projection",
          text: "New projection"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_form_field, {
              type: "select-string",
              list: _ctx.availableYears,
              modelValue: _ctx.selectedYearString,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedYearString) = $event)),
              labelKey: "Base year",
              labelValue: "Base year",
              placeholderKey: "Select a base year",
              placeholderValue: "Select a base year",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getScopesValues()))
            }, null, 8, ["list", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_form_field, {
              type: "number",
              modelValue: _ctx.model.targetYear,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.targetYear) = $event)),
              labelKey: "Near-term target setting",
              labelValue: "Near-term target setting",
              placeholderKey: "Near-term target setting",
              placeholderValue: "Near-term target setting"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("table", _hoisted_11, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Scope-01",
                  text: "Scope-01"
                })
              ]),
              _createElementVNode("th", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Scope-02",
                  text: "Scope-02"
                })
              ]),
              _createElementVNode("th", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Scope-03",
                  text: "Scope-03"
                })
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.scope1KgCo2e)) + " ", 1),
                _hoisted_12
              ]),
              _createElementVNode("td", null, [
                _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.scope2KgCo2e)) + " ", 1),
                _hoisted_13
              ]),
              _createElementVNode("td", null, [
                _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.scope3KgCo2e)) + " ", 1),
                _hoisted_14
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_form_field, {
              type: "number",
              step: 0.1,
              modelValue: _ctx.model.scope1ReductionPercentage,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.scope1ReductionPercentage) = $event)),
              labelKey: "Scope-01 reduction (%)",
              labelValue: "Scope-01 reduction (%)",
              placeholderKey: "Scope-01 reduction (%)",
              placeholderValue: "Scope-01 reduction (%)"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_form_field, {
              type: "number",
              step: 0.1,
              modelValue: _ctx.model.scope2ReductionPercentage,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.scope2ReductionPercentage) = $event)),
              labelKey: "Scope-02 reduction (%)",
              labelValue: "Scope-02reduction (%)",
              placeholderKey: "Scope-02 reduction (%)",
              placeholderValue: "Scope-02 reduction (%)"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_form_field, {
              type: "number",
              step: 0.1,
              modelValue: _ctx.model.scope3ReductionPercentage,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.scope3ReductionPercentage) = $event)),
              labelKey: "Scope-03 reduction (%)",
              labelValue: "Scope-03 reduction (%)",
              placeholderKey: "Scope-03 reduction (%)",
              placeholderValue: "Scope-03 reduction (%)"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.disabled,
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.createProjection()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Create projection",
            text: "Create projection"
          })
        ], 8, _hoisted_20)
      ])
    ])
  ]))
}